export const sortNotes = (notes) => {
    return notes.sort((x, y) => {
        return x.noteType === "Client" && y.noteType !== "Client" ? -1 : x.noteType !== "Client" && y.noteType === "Client" ? 1 : 0 || new Date(y.createdOn) - new Date(x.createdOn);
    });
};

export const hasSpecificNotes = (notes, taskType) => {
    if (taskType) {
        return notes.filter((n) => n.taskType === taskType || !n.taskType).length >= 1;
    } else {
        return notes.length >= 1;
    }
};
